import React, { useEffect, createElement } from 'react';
import { AnnouncementBar } from './components/sections/AnnouncementBar';
import { Hero } from './components/sections/Hero';
import { Identification } from './components/sections/Identification';
import { ProblemSolution } from './components/sections/ProblemSolution';
import { Results } from './components/sections/Results';
import { CourseContent } from './components/sections/CourseContent';
import { Bonuses } from './components/sections/Bonuses';
import { Testimonials } from './components/sections/Testimonials';
import { Pricing } from './components/sections/Pricing';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
// Add TypeScript declaration for Meta Pixel
declare global {
  interface Window {
    fbq: any;
  }
}
export function App() {
  // Meta Pixel Integration — loads SDK + fires PageView on mount
  useEffect(() => {
    // Avoid re-initializing if already loaded
    if (window.fbq) return;
    // Official Meta Pixel base code
    const n: any = window.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    if (!(window as any)._fbq) (window as any)._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    // Inject the fbevents.js script
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const s = document.getElementsByTagName('script')[0];
    s?.parentNode?.insertBefore(t, s);
    // Init pixel and track PageView
    window.fbq('init', '4327511617495565');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen bg-white font-sans selection:bg-rose-200 selection:text-rose-900" data-id="element-0">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=4327511617495565&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <AnnouncementBar data-id="element-3" />
      <main data-id="element-4">
        <Hero data-id="element-5" />
        <Identification data-id="element-6" />
        <ProblemSolution data-id="element-7" />
        <Results data-id="element-8" />
        <CourseContent data-id="element-9" />
        <Bonuses data-id="element-10" />
        <Testimonials data-id="element-11" />
        <Pricing data-id="element-12" />
        <FAQ data-id="element-13" />
        <FinalCTA data-id="element-14" />
      </main>

      <footer className="bg-gray-900 text-gray-400 py-8 text-center text-sm" data-id="element-15">
        <div className="max-w-7xl mx-auto px-4" data-id="element-16">
          <p data-id="element-17">
            © {new Date().getFullYear()} Ejercitá en Casa. Todos los derechos
            reservados.
          </p>
          <p className="mt-2 text-xs text-gray-500" data-id="element-18">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca comercial de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}